/* ==========================================================================
   JrTrack 5 PDP — client-side interactions
   - Bundle variant selection (syncs price + variant ID for cart form)
   - Gallery thumbnail switching (images + video)
   - Benefits / Membership tab toggling
   ========================================================================== */
(function () {
  'use strict';

  // --------------------------------------------------------------------------
  // Bundle / variant selector
  // --------------------------------------------------------------------------
  // Each .upgrade-card should have data-variant-id, data-price, data-compare-price,
  // and data-image (URL of the bundle's hero image) populated by Liquid.
  const upgradeCards = document.querySelectorAll('.upgrade-card');
  const currentPriceEl = document.querySelector('.current-price');
  const originalPriceEl = document.querySelector('.original-price');
  const discountBadgeEl = document.querySelector('.discount-badge');
  const planComparePriceEls = document.querySelectorAll('[data-plan-compare-price]');
  const variantIdInput = document.getElementById('selected-variant-id');
  const primeTargets = [
    '#amzn-buy-now',
    '#prime-block',
    'delivery-promise-wc'
  ];
  const heroSection = document.querySelector('.hero');
  const DEFAULT_PRODUCT_IMAGE = heroSection?.dataset.watchImage || 'https://cosmotogether.com/cdn/shop/files/1_64886b60-607e-4750-bc8b-a91a02c84413.webp?v=1779285066&width=1500';
  const OTHER_PRODUCT_IMAGE = heroSection?.dataset.bundleImage || DEFAULT_PRODUCT_IMAGE;
  const decodeHtml = (value) => {
    if (!value) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };
  const setPrimeAvailability = (isMainProductSelected) => {
    primeTargets.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.style.display = isMainProductSelected ? '' : 'none';
      });
    });
  };

  const switchOptionContent = (optionType) => {
    const resolvedType = optionType === 'refurbished' ? 'refurbished' : optionType === 'bundle' ? 'bundle' : 'watch';
    const benefitsTab = document.querySelector('.info-tab');
    const onBenefitsTab = !benefitsTab || benefitsTab.classList.contains('active');

    document.querySelectorAll('[data-option-shipping]').forEach((el) => {
      el.hidden = el.dataset.optionShipping !== resolvedType;
    });
    document.querySelectorAll('[data-option-benefits]').forEach((el) => {
      el.hidden = !onBenefitsTab || el.dataset.optionBenefits !== resolvedType;
    });
    document.querySelectorAll('[data-option-membership]').forEach((el) => {
      el.hidden = onBenefitsTab || el.dataset.optionMembership !== resolvedType;
    });
    document.querySelectorAll('[data-option-membership-note]').forEach((el) => {
      el.hidden = onBenefitsTab || el.dataset.optionMembershipNote !== resolvedType;
    });
  };

  const updateGalleryImage = (newImageUrl) => {
    if (!newImageUrl) return;

    const firstThumb = document.querySelector('.gallery-thumbs .thumb:not([data-video])') || document.querySelector('.gallery-thumbs .thumb');
    const mainImg = document.getElementById('main-image');
    const videoEl = document.getElementById('main-video');

    if (firstThumb) {
      const allGalleryThumbs = document.querySelectorAll('.gallery-thumbs .thumb');
      allGalleryThumbs.forEach((thumb) => thumb.classList.remove('active'));
      firstThumb.classList.add('active');
      firstThumb.dataset.img = newImageUrl;
      const thumbImg = firstThumb.querySelector('img');
      if (thumbImg) thumbImg.src = newImageUrl;
    }
    if (videoEl) videoEl.style.display = 'none';
    if (mainImg) {
      mainImg.style.display = 'block';
      mainImg.src = newImageUrl;
    }
  };

  upgradeCards.forEach((card) => {
    card.addEventListener('click', () => {
      upgradeCards.forEach((c) => c.classList.remove('selected'));
      card.classList.add('selected');

      const isMainProductSelected = card.dataset.isMainProduct !== 'false';
      const optionType = card.dataset.optionType || (isMainProductSelected ? 'watch' : 'bundle');
      let newImageUrl = card.dataset.image;
      if (!newImageUrl) {
        newImageUrl = optionType === 'bundle' ? OTHER_PRODUCT_IMAGE : DEFAULT_PRODUCT_IMAGE;
      }
      updateGalleryImage(newImageUrl);
      switchOptionContent(optionType);

      // Update pricing display
      if (card.dataset.price && currentPriceEl) {
        currentPriceEl.innerHTML = decodeHtml(card.dataset.price);
      }
      if (originalPriceEl) {
        originalPriceEl.innerHTML = card.dataset.comparePrice ? decodeHtml(card.dataset.comparePrice) : '';
        originalPriceEl.style.display = card.dataset.comparePrice ? '' : 'none';
      }
      if (discountBadgeEl) {
        discountBadgeEl.textContent = card.dataset.discountPercent ? `${card.dataset.discountPercent}% OFF` : '';
        discountBadgeEl.style.display = card.dataset.discountPercent ? '' : 'none';
      }
      planComparePriceEls.forEach((el) => {
        el.innerHTML = card.dataset.comparePrice ? decodeHtml(card.dataset.comparePrice) : '';
        el.style.display = card.dataset.comparePrice ? '' : 'none';
      });

      // Update the hidden variant ID that gets posted to /cart/add
      if (card.dataset.variantId && variantIdInput) {
        variantIdInput.value = card.dataset.variantId;
      }
      setPrimeAvailability(isMainProductSelected);
    });
  });
  const initiallySelectedCard = document.querySelector('.upgrade-card.selected');
  if (initiallySelectedCard) {
    const initialOptionType = initiallySelectedCard.dataset.optionType || (initiallySelectedCard.dataset.isMainProduct !== 'false' ? 'watch' : 'bundle');
    switchOptionContent(initialOptionType);
    setPrimeAvailability(initiallySelectedCard.dataset.isMainProduct !== 'false');
  }

  // --------------------------------------------------------------------------
  // Tab switching (Benefits / Membership)
  // --------------------------------------------------------------------------
  const tabs = document.querySelectorAll('.info-tab');
  const membershipPanel = document.getElementById('tab-membership');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      const selectedOption = document.querySelector('.upgrade-card.selected');
      const optionType = selectedOption
        ? (selectedOption.dataset.optionType || (selectedOption.dataset.isMainProduct !== 'false' ? 'watch' : 'bundle'))
        : 'watch';

      if (index === 0) {
        if (membershipPanel) membershipPanel.classList.add('tab-hidden');
      } else {
        if (membershipPanel) membershipPanel.classList.remove('tab-hidden');
      }
      switchOptionContent(optionType);
    });
  });

  // --------------------------------------------------------------------------
  // Gallery thumbnail click + nav arrows
  // --------------------------------------------------------------------------
  const mainImage = document.getElementById('main-image');
  const mainVideo = document.getElementById('main-video');
  const thumbsContainer = document.querySelector('.gallery-thumbs');
  const allThumbs = document.querySelectorAll('.thumb');
  const ensureThumbFullyVisible = (thumb) => {
    if (!thumbsContainer || !thumb) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    const containerRect = thumbsContainer.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    const leftOverflow = thumbRect.left - containerRect.left;
    const rightOverflow = thumbRect.right - containerRect.right;

    if (leftOverflow < 0) {
      thumbsContainer.scrollBy({ left: leftOverflow - 8, behavior: 'smooth' });
    } else if (rightOverflow > 0) {
      thumbsContainer.scrollBy({ left: rightOverflow + 8, behavior: 'smooth' });
    }
  };
  allThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      allThumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      ensureThumbFullyVisible(thumb);
      if (thumb.dataset.video) {
        if (mainImage) mainImage.style.display = 'none';
        if (mainVideo) mainVideo.style.display = 'block';
      } else if (thumb.dataset.img) {
        if (mainVideo) mainVideo.style.display = 'none';
        if (mainImage) {
          mainImage.style.display = 'block';
          mainImage.src = thumb.dataset.img;
        }
      }
    });
  });

  const thumbArray = [...allThumbs];
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const active = document.querySelector('.thumb.active');
      const idx = thumbArray.indexOf(active);
      const prev = thumbArray[(idx - 1 + thumbArray.length) % thumbArray.length];
      prev.click();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const active = document.querySelector('.thumb.active');
      const idx = thumbArray.indexOf(active);
      const next = thumbArray[(idx + 1) % thumbArray.length];
      next.click();
    });
  }
})();
